import React from 'react'

export default function Historys() {
  return (
    <div className='historyWrap' id='history'>
      <span className='title'>03. HISTORY</span>
      <ul>
        <li><span>2025.03 ~ </span><p>모바일팩토리 입사</p></li>
        <li><span>2020.04 ~ 2020.09</span><p>[실무프로젝트] 자바 웹개발자(React, Springboot, intelliJ, AWS)</p></li>
        <li><span>2020.12 ~ 2024.01</span><p>에코마케팅 디자인팀 프로덕트 파트 선임</p></li>
        <li><span>2015.03 ~ 2019.08</span><p>상명대학교 디지털콘테츠과 졸업</p></li>
      </ul>
    </div>
  )
}
